/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.services {
    export class AssignmentConfigurationService extends services.DataService<Wars.Domain.Model.AssignmentConfiguration>{
        constructor(injectedBreeze: typeof breeze, $q: angular.IQService) {
            super(injectedBreeze, $q);
        }

        public createAssigmentSectionClaim(): Wars.Domain.Model.AssignmentSectionClaim{
            return this.createNewEntity<Wars.Domain.Model.AssignmentSectionClaim>("AssignmentSectionClaim");
        }
    }
}

warsApp.registerService('AssignmentConfigurationService',['breeze','$q']);